import { Cart } from '../components/Cart'
import React from 'react'

const CartPage: React.FC = () => {
  return <Cart />
}

export default CartPage
